import React, { useEffect, useState } from "react";
import classNames from "classnames";
import WarningIcon from "icons/warning-yellow-big.svg";
import InfoIcon from "icons/validationInfo.svg";
import CloseIcon from "icons/close.svg";
import * as styles from "./styles.module.scss";
export var ResultInfoMessageType;
(function (ResultInfoMessageType) {
    ResultInfoMessageType["LONG_CALCULATION"] = "longCalculation";
    ResultInfoMessageType["COPIED_TO_CLIPBOARD"] = "copiedToClipboard";
})(ResultInfoMessageType || (ResultInfoMessageType = {}));
const typesState = {
    [ResultInfoMessageType.LONG_CALCULATION]: {
        text: "Still calculating - workspaces with multiple parameters/scales and high granularity will take time.",
        icon: WarningIcon,
        className: styles.warning,
    },
    [ResultInfoMessageType.COPIED_TO_CLIPBOARD]: {
        text: "Data copied to clipboard. Press Ctrl+V to use it.",
        icon: InfoIcon,
        className: styles.info,
    },
};
const ResultInfoMessage = ({ visible, type, className, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);
    const { text, className: typeClassName } = typesState[type];
    useEffect(() => {
        setIsVisible(!!visible);
    }, [visible]);
    return (React.createElement("div", { className: classNames(styles.root, className, typeClassName, { [styles.visible]: isVisible }) },
        React.createElement("span", { className: styles.text }, text),
        React.createElement(CloseIcon, { className: styles.closeIcn, onClick: () => {
                setIsVisible(false);
                onClose && onClose();
            } })));
};
export default ResultInfoMessage;
